import { openAlertModal } from 'admin/actions/alert-modal';
import { hideLoadingSpinner,showLoadingSpinner } from 'admin/actions/loading-spinner';
import { getQRDesign } from 'admin/actions/qr-designer';
import Select from 'admin/components/atoms/Select';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import { toQueryParams } from 'admin/utils';
import React,{ Component } from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import PageSelector from './PageSelector';
import QRPreview from './QRPreview';
import styles from './styles.scss';
import UserPrivateMoneyNotAllowed from '../../atoms/UserPrivateMoneyNotAllowed';
import SelectedPrivateMoneyDisplay from '../../organisms/SelectedPrivateMoneyDisplay';

const Wrapper = styled.div`
  ${Select} {
    width: 300px;
  }
`;

function readDataURI(dataURI) {
  if (typeof dataURI !== 'string') {
    return null;
  }
  const result = dataURI.match('^data:(image/(?:jpeg|png|gif));base64,(.+)');
  if (result) {
    const [, mediaType, data] = result;
    return new Blob([new Buffer(data, 'base64')], { type: mediaType });
  } else {
    return null;
  }
}

function fileExtToMediaType(uri) {
  const [, ext] = uri.match('\\.(\\w+)$');
  switch (ext) {
    case 'png':
      return 'image/png';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'gif':
      return 'image/gif';
    default:
      return null;
  }
}

function readImageURI(uri, onload) {
  const result = readDataURI(uri);
  if (result) {
    onload(result);
    return;
  }

  const image = new Image();
  image.crossOrigin = "Anonymous";
  image.src = uri;
  image.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    canvas.getContext('2d').drawImage(image, 0, 0);
    onload(readDataURI(canvas.toDataURL(fileExtToMediaType(uri))));
  }
}

class QRDesigner extends Component {

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      isSelectedMoneyAllowed: props.user.issuedMoneys().some((m) => m.id === props.userPrivateMoney.id),
    }
  }

  componentDidMount() {
    if (!this.state.isSelectedMoneyAllowed) return;
    this.props.getQRDesign(toQueryParams({ private_money_id: this.props.userPrivateMoney.id }));
  }

  componentDidUpdate(prevProps) {
    if (!this.state.isSelectedMoneyAllowed) return;
    if (prevProps.userPrivateMoney.id !== this.props.userPrivateMoney.id) {
      this.props.getQRDesign(toQueryParams({ private_money_id: this.props.userPrivateMoney.id }));
    }
  }

  handleSave = () => {
    this.props.showLoadingSpinner();
    const data = this.props.data;
    readImageURI(data.backgroundImage,
      (backgroundImage) => {
        const formData = new FormData();
        formData.append('_csrf_token', window._csrf_token);
        if (backgroundImage) formData.append('background_image', backgroundImage);
        formData.append('width', data.width);
        formData.append('height', data.height);
        formData.append('qrcode_x', data.qrcode.x);
        formData.append('qrcode_y', data.qrcode.y);
        formData.append('qrcode_size', data.qrcode.size);
        formData.append('caption_x', data.caption.x);
        formData.append('caption_y', data.caption.y);
        formData.append('caption_size', data.caption.size);
        formData.append('caption_color', data.caption.color);
        fetch(`/api/merchandise-tag?private_money_id=${this.props.userPrivateMoney.id}`, {
          method: 'POST',
          credentials: 'same-origin',
          body: formData,
        })
        .then((response) => {
          if (!response.ok) {
            throw 'エラーが発生しました';
          }
          return response;
        })
        .then(() => {
          this.props.openAlertModal({
            body: (
              <span>保存しました</span>
            ),
            useCancel: false,
          });
          this.props.history.push('/settings/qr-design');
        })
        .catch(() => {
          this.props.openAlertModal({
            body: (
              <span>エラーが発生しました。管理者へお問合せください</span>
            ),
            useCancel: false,
            confirmColor: 'danger',
          });
        })
        .finally(() => {
          this.props.hideLoadingSpinner();
        });
      });
  }

  render() {

    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'QRデザイン', href: '/settings/qr-designer', active: true },
    ];
    return (
      <Wrapper>
        <Breadcrumb items={crumb} />
        <SelectedPrivateMoneyDisplay highlightHeader={!this.state.isSelectedMoneyAllowed} />
        {!this.state.isSelectedMoneyAllowed && <UserPrivateMoneyNotAllowed />}
        {this.state.isSelectedMoneyAllowed && (
          <>
            <div styleName="headline">デザイン設定</div>
            <div styleName="body">
              <div styleName="leftPane">
                <PageSelector page={this.props.page} onSave={this.handleSave} />
              </div>
              <div styleName="separator"></div>
              <div styleName="rightPane">
                <QRPreview page={this.props.page} />
              </div>
            </div>
          </>
        )}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  userPrivateMoney: state.userPrivateMoney.selectedMoney,
  page: state.qrDesigner.page,
  data: {
    backgroundImage: state.qrDesigner.backgroundImage,
    qrcode: state.qrDesigner.qrcode,
    caption: state.qrDesigner.caption,
    width: state.qrDesigner.size.width,
    height: state.qrDesigner.size.height,
  },
});

export default withRouter(connect(mapStateToProps, {
  getQRDesign,
  showLoadingSpinner,
  hideLoadingSpinner,
  openAlertModal
})(CSSModules(QRDesigner, styles)));
